import UserCard from './UserCard';

export default UserCard;


// WEBPACK FOOTER //
// ./src/pages/chat/conversations/user-card/index.js